<template>
  <px-lateral-dialog v-model="dialog" width="800">
    <template v-slot:activator="{ on }">
      <v-btn class="normal-btn-text rounded-tag-small elevation-0 ml-3"
             color="error" small
             v-on="on">
        Recusar
      </v-btn>
    </template>
    <template v-slot:title>
      Recusar compra
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="required rounded-tag-small"
            label="Motivo da recusa"
            counter="1500"
            rows="4"
            v-model="motivoRecusa"
            :error="$v.motivoRecusa.$error"
            @blur="$v.motivoRecusa.$touch()"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn class="rounded-tag-small normal-btn-text elevation-0" @click="close">
        Fechar
      </v-btn>
      <v-btn color="error"
             :loading="loading"
             class="rounded-tag-small normal-btn-text elevation-0"
             @click="onClickRecusar">
        Recusar
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import AprovacaoService from '@/modules/aprovacao/aprovacao-service';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      motivoRecusa: null,
    };
  },
  methods: {
    onClickRecusar() {
      if (this.validateForm()) {
        return;
      }
      this.recusar();
    },
    recusar() {
      this.loading = true;
      AprovacaoService.recusar(this.aprovacao.id, { motivoRecusa: this.motivoRecusa })
        .then(() => {
          this.$toast('Compra recusada', { color: 'success' });
          this.$emit('update');
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    },
  },
  validations: {
    motivoRecusa: {
      required,
    },
  },
};
</script>
